export default __webpack_public_path__ + "AMS-7007-24-01-14.csv";